import { render } from "./FooterPIT.vue?vue&type=template&id=1e03cf6e&scoped=true"
import script from "./FooterPIT.vue?vue&type=script&lang=js"
export * from "./FooterPIT.vue?vue&type=script&lang=js"

import "./FooterPIT.vue?vue&type=style&index=0&id=1e03cf6e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4222023534/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e03cf6e"]])

export default __exports__